import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Input, TreeSelect } from 'antd';
import { useNavigate } from "react-router-dom";
import logo from "../../dist/img/logo.png";
import CategorySlider from "./category/category_slider";
import { SearchOutlined } from '@mui/icons-material';

import settings_sliders from '../../dist/icons/settings_sliders.svg'
import RoundedButton from './rounded_button';


const { Search } = Input;
const { TreeNode } = TreeSelect;

const SearchBar = ({ query }) => {
    const [value, setValue] = useState(undefined);
    const [search, setSearch] = useState(query ?? '');
    const history = useNavigate();

    const onChange = () => {
        setValue(value);
    }
    const SearchFilter = ()=>{
        
    }
    const handleSearch = () => {
        history(`/search-result?q=${search}`);
    }

    const handleChange = (value) => {
        console.log(`selected ${value}`);
        window.location.href = "/category/" + value;
    };

    return (
        <div>
            <div className="col-md-12">

                <div className="flex flex-row mt-4 mx-1 align-items-center justify-content-between">

                    <div className='flex-grow flex items-center justify-center'>
                        <input
                            type={"search"}
                            className='rounded-xl px-4 py-2 w-full border border-neutral-200 bg-zinc-100 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent'
                            placeholder="Я ищу..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearch();
                                }
                            }}
                        />
                        <SearchOutlined className='relative right-8  text-gray-400 ' />
                    </div>
                    <button
                        className='btn btn-primary rounded-xl px-[60px] py-[7px] ml-2 d-md-none d-lg-block d-sm-none d-xs-none'
                        type="primary"
                        onClick={handleSearch}>
                        Найти
                    </button>
                    <RoundedButton
                        className='d-md-block d-lg-none'
                        onClick={() => {
                            console.log('')
                        }}
                    >
                        <SearchOutlined />
                    </RoundedButton>
                </div>
                <div className="col-md-12 mt-3 pb-3 px-0">
                    <CategorySlider />
                </div>
            </div>
        </div>
    );
}

export default SearchBar;